export const iconFontAwesomePunctuationSymbolsCircleQuestion = (
	<i className="fa-solid fa-circle-question"></i>
);
